import React, { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  Typography,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import {
  Search as SearchIcon,
  FiberManualRecord as DotIcon,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  searchField: {
    marginBottom: theme.spacing(1),
  },
  list: {
    maxHeight: 400,
    overflow: "auto",
  },
  loadingCenter: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(3),
  },
  emptyText: {
    textAlign: "center",
    padding: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  colorDot: {
    minWidth: 28,
    "& svg": { fontSize: 14 },
  },
}));

const QueueSelectionDialog = ({ open, onClose, onSelect }) => {
  const classes = useStyles();
  const [queues, setQueues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!open) return;
    let cancelled = false;

    const fetchQueues = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/queue");
        if (!cancelled) setQueues(data || []);
      } catch (err) {
        console.error("[QueueSelectionDialog] error:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchQueues();
    return () => { cancelled = true; };
  }, [open]);

  const filtered = search.trim()
    ? queues.filter((q) =>
        (q.name || "").toLowerCase().includes(search.toLowerCase())
      )
    : queues;

  const handleSelect = useCallback(
    (queueId) => {
      onSelect(queueId);
    },
    [onSelect]
  );

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Trocar Fila</DialogTitle>
      <DialogContent>
        <TextField
          className={classes.searchField}
          placeholder="Buscar fila..."
          fullWidth
          size="small"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        {loading ? (
          <div className={classes.loadingCenter}>
            <CircularProgress size={24} />
          </div>
        ) : filtered.length === 0 ? (
          <Typography className={classes.emptyText}>
            Nenhuma fila encontrada
          </Typography>
        ) : (
          <List className={classes.list} dense>
            {filtered.map((queue) => (
              <ListItem
                key={queue.id}
                button
                onClick={() => handleSelect(queue.id)}
              >
                <ListItemIcon className={classes.colorDot}>
                  <DotIcon style={{ color: queue.color || "#757575" }} />
                </ListItemIcon>
                <ListItemText
                  primary={queue.name}
                  secondary={queue.greetingMessage ? "Com saudação" : undefined}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QueueSelectionDialog);
